export default __webpack_public_path__ + "static/media/second.5ddb73be.jpg";